import { environment } from "src/environments/environment";
import { CurrencyMap, RouteParamHeadings } from "./constant-interface";
export class Constant {

  public static readonly Currency:string = 'GeneralCurrency';
  public static readonly ProfitCenter :string = 'ProfitCenter';
  public static readonly BusinessUnit :string = 'BusinessUnit';
  public static readonly RateType :string = 'JobRequestRateType';
  public static readonly PayType :string = 'jobRequestPayType';
  public static readonly Countries :string = 'Countries';
  public static readonly States :string = 'States';
  public static readonly JobType :string = 'jobRequestJobType';
  public static readonly Fixed :string = 'FX';
  public static readonly Range :string = 'RNG';
  public static readonly JobCategory :string = 'JobRequestJobCategory';
  public static readonly ExperienceLevel :string = 'JobRequestExperienceLevel';
  public static readonly JobRequestContract :string = 'JobRequestContract';
  public static readonly SupplierContacts :string = 'SupplierSupplierContacts';
  public static readonly JobProfileStatus :string ='JobRequestProfileStatus';
  public static readonly JobAllotmentStatus :string ='SuppJobAllotmentStatus';
  public static readonly Draft :string ='Draft';
  public static readonly Submitted :string ='Submitted';
  public static readonly Approved :string ='Approved';
  public static readonly Rejected :string ='Rejected';
  public static readonly Expired :string ='Expired';
  public static readonly Active :string ='Active';
  public static readonly InActive :string ='InActive';
  public static readonly Closed :string ='Closed';
  public static readonly Assigned :string ='Assigned'
  public static readonly NotAssigned :string ='Not Assigned'
  public static readonly BadgePrimary :string = 'primary';
  public static readonly BadgeSuccess :string = 'success';
  public static readonly BadgeDanger :string = 'danger';
  public static readonly BadgeWarning :string = 'warning';
  public static readonly BadgeHold :string = 'hold';
  public static readonly BadgeGrey :string = 'yellow';
  public static readonly BadgeBoard :string = 'green';
  public static readonly WorkFlowStatus :string = 'Supplier.WorkFlowStatus';
  public static readonly SuppProfileStatus :string = 'SuppProfileStatus';
  public static readonly Verified :string = 'Verified';
  public static readonly JsVerified :string = 'VERIFIED';
  public static readonly NonVerified :string = 'Non-Verified';
  public static readonly NonVerify :string = 'NONVERIFIED';
  public static readonly Withdraw :string = 'WITHDRAW';
  public static readonly ROUTE_PARAM_HEADINGS:RouteParamHeadings ={jobseeker: "Job Seeker", client:"Client", supplier:"Supplier", admin:"Admin", resetpassword:"Reset Password", forgotpassword:"Forgot Password"};
  // Please add url that do not include sidebar
  public static readonly ROUTE_HEADINGS: string[]  =["/login/resetpassword/",
  "/login/supplier",
  "/login/jobSeeker",
  "/login/client",
  "/login/admin",
  "/auth/forgotpassword","/home"];
  public static readonly ROUTE_HEADINGS_NL: string[]  =["resetpassword","invite/profile","invite/link","dsl/verifycode","dsl/verify","/error","invite/emailverify"];

  public static formatDate(dateString: string, useUTC: boolean = false): string {
    const date = new Date(dateString);
    if (useUTC) {
        return date.toLocaleDateString('en-US', {
            timeZone: 'UTC',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    } else {
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    }
}

  public static readonly Currencies :CurrencyMap= {
      USD: { code: 1, symbol: 'USD - ' },
      CAD: { code: 2, symbol: 'CAD - ' },
      INR: { code: 3, symbol: 'INR - ' },

    };

  public static readonly NotFound : string = 'Not found';
  public static readonly UserNotAuthorized : string = 'user is not authorized';
  public static readonly HaveNotPermission : string = 'You are not authorised to perform this action';
  public static readonly BadRequest : string = 'Bad Request';
  public static readonly ServiceUnAvailable : string = 'Service unavailable';
  public static readonly SomethingWrong : string = 'Something went wrong';
  public static readonly TokenExpire : string = 'Token is expired';

  public static readonly EntryLevelCode = "ENTLVL";
  public static readonly IntLevelCode = "INTMDT";
  public static readonly MidlevelCode = "MDLVL";
  public static readonly ExecuteLevelCode = "SOE";
  public static readonly EntryLevelDisplay = "Entry-level";
  public static readonly IntLevelDisplay = "Intermediate";
  public static readonly MidlevelDisplay = "Mid-level";
  public static readonly ExecuteLevelDisplay = "Senior or executive-level";
  public static readonly NoData = "No Data Found";
  public static readonly SourceJob = "InHouse";
  public static readonly Virtusa = "Virtusa";
  public static readonly Veriklick = "Veriklick";
  public static readonly Accept = "accept";
  public static readonly Reject = "reject";
  public static readonly Close = "close";
  public static readonly Approve = "approve";
  public static readonly EmailNotFound = "Email not found.";
  public static readonly ProfileNotFound = "Profile not found.";
  public static readonly AssociationFound = "Association found.";
  public static readonly AssociationNotFound = "Association not found.";
  public static readonly ProfileFound = "Profile found.";

};
export enum jobSeekerStatus
{
  SUBMITTED = "SUBMITTED",
  ONBOARDED = "ONBOARDED"
}

export enum ComponentKey
{
  JOBSEEKER = "jobseeker",
  SUPPLIER = "supplier",
  JOBREQUEST = "jobrequest",
  USER = "user",
  SUPPLIERGROUP = "suppliergroup",
  CLIENT = "client",
  VENDOR = "vendor",
  SVENDOR = "svendor"
}
